/**
 * Centralizes Vite `import.meta.env` string reads. Jest substitutes this module
 * via `moduleNameMapper` because `import.meta` is not valid in the default
 * Jest CJS evaluation path for this repo's ts-jest preset.
 */
export function getViteEnvString(key: string): string | undefined {
  const raw = import.meta.env[key as keyof ImportMetaEnv];
  if (typeof raw === 'string' && raw.trim().length > 0) {
    return raw.trim();
  }
  return undefined;
}
